module.exports = __webpack_public_path__ + "img/title.fd6fab61.png";